<template>
    <div class="el-cal-item-container">
        <div v-if="booking.allDay" class="el-cal-item el-cal-item--small">
            <div class="el-cal-item__time-slot">
                {{
                    (booking.DateFrom && booking.DateFrom.toFormat('HH:mm')) ||
                    booking.start.format('HH:mm')
                }}
                -
                {{
                    (booking.DateTo && booking.DateTo.toFormat('HH:mm')) ||
                    booking.end.format('HH:mm')
                }}
            </div>
            <el-row>
                <div class="el-cal-item__title">
                    <div class="el-cal-item__title-text font-medium">
                        {{ this.actorType(booking.ActorType) || '' }}
                    </div>
                </div>
            </el-row>
        </div>
        <div v-else class="el-cal-item">
            <el-row>
                <div
                    class="
                        el-cal-item__time-slot
                        flex
                        justify-between
                        mr-6
                        mb-2
                    "
                >
                    <span>
                        {{
                            (booking.DateFrom &&
                                booking.DateFrom.toFormat('HH:mm')) ||
                            booking.start.format('HH:mm')
                        }}
                        -
                        {{
                            (booking.DateTo &&
                                booking.DateTo.toFormat('HH:mm')) ||
                            booking.end.format('HH:mm')
                        }}
                        <img
                            src="/images/icon/images-icon-black.png"
                            style="
                                width: 18px;
                                position: absolute;
                                margin-left: 5px;
                                margin-top: -4px;
                            "
                            v-if="checkImages(booking)"
                        />
                    </span>
                    <span
                        v-if="booking.ActorType === 'PROPOSED SLOT'"
                        style="
                            text-align: center;
                            font-size: 14px;
                            font-weight: bold;
                        "
                        >{{ trans('form.label.clickToFineTune') }}
                    </span>
                    <el-tooltip
                        effect="light"
                        :content="trans('form.label.existingBooking')"
                        placement="top"
                    >
                        <v-icon
                            v-show="
                                isOverlapperd &&
                                booking.ActorType === 'PROPOSED SLOT'
                            "
                            style="color: rgb(249, 113, 0); border-radius: 22px"
                            >info</v-icon
                        >
                    </el-tooltip>
                    <span
                        class="tentative-confirmed-tag"
                        v-if="
                            booking.ActorType === 'TENTATIVE' &&
                            booking.Status !== 1
                        "
                    >
                        {{ trans('form.label.tentative') }}
                    </span>
                    <span v-else>
                        {{ this.actorType(booking.ActorType) || '' }}
                    </span>
                </div>
            </el-row>

            <div class="el-cal-item__body">
                <div
                    v-for="bookingDetailObj in filters"
                    :key="bookingDetailObj.id"
                >
                    <div v-if="bookingDetailObj.checked">
                        <span
                            v-if="bookingDetailObj.name == 'reference'"
                            v-bind:class="[
                                bookingDetailObj.isHighlighted
                                    ? 'text_bold'
                                    : 'text_not_bold',
                            ]"
                        >
                            {{ toArray(booking.PackageGroups, 'Reference') }}
                        </span>
                        <span
                            v-if="bookingDetailObj.name == 'supplier'"
                            v-bind:class="[
                                bookingDetailObj.isHighlighted
                                    ? 'text_bold'
                                    : 'text_not_bold',
                            ]"
                        >
                            {{ toArray(booking.PackageGroups, 'SupplierName') }}
                        </span>
                        <span
                            v-if="bookingDetailObj.name == 'bookedBy'"
                            v-bind:class="[
                                bookingDetailObj.isHighlighted
                                    ? 'text_bold'
                                    : 'text_not_bold',
                            ]"
                        >
                            {{ booking.CreatedByUserName }}
                        </span>
                        <span
                            v-if="bookingDetailObj.name == 'pin'"
                            v-bind:class="[
                                bookingDetailObj.isHighlighted
                                    ? 'text_bold'
                                    : 'text_not_bold',
                            ]"
                        >
                            {{ booking.PinCode }}
                        </span>
                        <span
                            v-if="bookingDetailObj.name == 'additionalInfo'"
                            v-bind:class="[
                                bookingDetailObj.isHighlighted
                                    ? 'text_bold'
                                    : 'text_not_bold',
                            ]"
                        >
                            {{ booking.Comment }}
                        </span>

                        <span
                            v-if="bookingDetailObj.name == 'requestedResources'"
                            style="bottom: 10px; position: absolute"
                        >
                            <ul
                                v-for="requestedResource in booking.requestedResources"
                                :key="requestedResource.RequestID"
                                class="
                                    expanded
                                    resources-icon-list
                                    inline-block
                                "
                            >
                                <li
                                    v-if="
                                        requestedResource.ResourceType ===
                                        'FORKLIFT'
                                    "
                                    class="
                                        resource-icon resource-icon__transporter
                                    "
                                ></li>
                                <li
                                    v-if="
                                        requestedResource.ResourceType ===
                                        'TRUCK'
                                    "
                                    class="resource-icon resource-icon__truck"
                                ></li>
                                <li
                                    v-if="
                                        requestedResource.ResourceType ===
                                        'MANPOWER'
                                    "
                                    class="resource-icon resource-icon__team"
                                ></li>
                                <li
                                    v-if="
                                        requestedResource.ResourceType ===
                                        'CRANE'
                                    "
                                    class="resource-icon resource-icon__crane"
                                ></li>
                                <li
                                    v-if="
                                        requestedResource.ResourceType ===
                                        'TOOLS'
                                    "
                                    class="resource-icon resource-icon__tools"
                                ></li>
                            </ul>
                        </span>
                    </div>
                </div>
            </div>

            <div class="el-cal-item__footer">
                <i
                    class="material-icons"
                    v-if="booking.IsLocked"
                    style="font-size: 16px"
                >
                    lock
                </i>
                <span style="float: right">
                    {{ booking.UsageTimes }} / {{ booking.MaxUsageTimes }}
                </span>
            </div>
        </div>
        <div class="tippy-popper" ref="tooltip" v-if="booking">
            <v-card class="white--text v-card-round" width="700">
                <v-card-title primary-title :style="{ background: color }">
                    <v-layout>
                        <v-flex xs2>
                            <div>
                                <div class="subheading mb-3">
                                    {{ booking.BookingReference }}
                                </div>
                                <div class="subheading mb-1">
                                    {{ trans('form.label.pinCode') }}
                                </div>
                                <div class="subheading mb-1">
                                    {{ trans('form.label.bookedBy') }}
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs7>
                            <div>
                                <br />
                                <br />
                                <div class="subheading mb-1">
                                    : {{ booking.PinCode }}
                                </div>
                                <div class="subheading mb-1">
                                    : {{ booking.CreatedByUserName }}
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs3 justify-end>
                            <div>
                                <div class="mb-3 body-2">
                                    <v-layout justify-space-around>
                                        <v-btn
                                            icon
                                            small
                                            @click.stop="openTimeline(booking)"
                                        >
                                            <v-icon>info</v-icon>
                                        </v-btn>
                                        <v-btn
                                            v-if="
                                                !readonly &&
                                                booking.ActorType !==
                                                    'MILKRUN' &&
                                                booking.ActorType !==
                                                    'TENTATIVE'
                                            "
                                            @click="
                                                fireEvent(
                                                    'actor-editing',
                                                    booking
                                                )
                                            "
                                            icon
                                            small
                                        >
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn
                                            v-if="
                                                booking.ActorType ===
                                                'TENTATIVE'
                                            "
                                            @click="
                                                subscribeNotifications(
                                                    booking.IsSubscribed
                                                )
                                            "
                                            icon
                                            small
                                        >
                                            <v-icon>{{
                                                booking.IsSubscribed
                                                    ? 'notifications_active'
                                                    : 'notifications_off'
                                            }}</v-icon>
                                        </v-btn>
                                        <v-btn
                                            v-if="
                                                !readonly &&
                                                booking.ActorType !== 'MILKRUN'
                                            "
                                            @click="
                                                fireEvent(
                                                    'delete-booking',
                                                    booking
                                                )
                                            "
                                            icon
                                            small
                                        >
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                        <v-btn @click="tippy.hide()" icon small>
                                            <v-icon>clear</v-icon>
                                        </v-btn>
                                    </v-layout>
                                </div>
                                <p style="font-size: 16px; text-align: right">
                                    {{ booking.AccessSets[0].UnloadingArea
                                    }}<br />
                                    {{
                                        this.actorType(booking.ActorType) || ''
                                    }}
                                </p>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card-title>
                <v-card-text
                    class="pa-3 white black--text"
                    v-if="booking.DateFrom"
                >
                    <v-layout>
                        <v-flex xs6>
                            <v-icon class="mr-2">event_note</v-icon>
                            <div v-if="booking.allDay" class="body-2">
                                {{ booking.DateFrom.toLocaleString() }} -
                                {{ booking.DateTo.toLocaleString() }}
                            </div>
                            <div v-else class="body-2">
                                {{ booking.DateFrom.toLocaleString() }}
                            </div>
                        </v-flex>
                        <v-flex xs6>
                            <v-icon class="mr-2">schedule</v-icon>
                            <div class="body-2">
                                {{ booking.DateFrom.toFormat('HH:mm') }} -
                                {{ booking.DateTo.toFormat('HH:mm') }}
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout
                        class="mt-3"
                        v-for="(
                            packageGroup, index
                        ) in booking.PackageGroups.slice().reverse()"
                        :key="packageGroup.PackageGroupID"
                    >
                        <v-flex xs3>
                            <div>
                                <div class="body-1">
                                    {{ trans('data.label.referenceNo') }}
                                </div>
                                <div class="body-1">
                                    {{ trans('data.label.supplier') }}
                                </div>
                                <div class="body-1">
                                    {{ trans('data.label.items') }}
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs3>
                            <div>
                                <div class="body-1">
                                    : {{ packageGroup.Reference }}
                                </div>
                                <div class="body-1">
                                    : {{ packageGroup.SupplierName }}
                                </div>
                                <div class="body-1">
                                    <p
                                        v-for="(
                                            packageItem, index
                                        ) in packageGroup.PackageItems"
                                        :key="index"
                                    >
                                        :
                                        {{
                                            `${packageItem.Description} ${
                                                packageItem.PackageType
                                                    ? `(${packageItem.PackageType})`
                                                    : ''
                                            }`
                                        }}
                                    </p>
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs3 v-if="index === 0">
                            <div>
                                <div class="body-1">
                                    {{ trans('form.label.recipientName') }}
                                </div>
                                <div class="body-1">
                                    {{ trans('form.label.recipientCompany') }}
                                </div>
                                <div class="body-1">
                                    {{ trans('form.label.recipientPhone') }}
                                </div>
                            </div>
                        </v-flex>
                        <v-flex
                            xs3
                            v-if="index === 0 && booking.AccessSets.length"
                        >
                            <div>
                                <div class="body-1">
                                    : {{ booking.AccessSets[0].RecipientName }}
                                </div>
                                <div class="body-1">
                                    :
                                    {{ booking.AccessSets[0].RecipientCompany }}
                                </div>
                                <div class="body-1">
                                    : {{ booking.AccessSets[0].RecipientPhone }}
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout style="padding-top: 15px">
                        <v-flex xs3>
                            <div class="body-1">
                                {{ trans('table.column.comments') }}
                            </div>
                        </v-flex>
                        <v-flex xs9>
                            <div class="body-1">: {{ booking.Comment }}</div>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-title primary-title :style="{ background: '#5D5E61' }">
                    <v-layout>
                        <v-flex xs3>
                            <div>
                                <div class="body-1">
                                    {{ trans('form.label.usageTime') }}
                                </div>
                                <div class="body-1">
                                    {{ trans('form.label.maxUsageTime') }}
                                </div>
                                <div class="body-1">
                                    {{ trans('form.label.numberPlate') }}
                                </div>
                                <div v-if="booking.IsLocked" class="body-1">
                                    <i
                                        class="material-icons"
                                        v-if="booking.IsLocked"
                                        style="font-size: 16px"
                                    >
                                        lock
                                    </i>
                                    {{ trans('form.label.locked') }}
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs3>
                            <div>
                                <div class="body-1">
                                    : {{ booking.UsageTimes }}
                                </div>
                                <div class="body-1">
                                    : {{ booking.MaxUsageTimes }}
                                </div>
                                <div class="body-1">
                                    : {{ booking.PlateNo }}
                                </div>
                                <div v-if="booking.IsLocked" class="body-1">
                                    : {{ booking.LockedByUserName }}
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs3>
                            <div>
                                <div class="body-1">
                                    {{ trans('table.data.label.preFlex') }}
                                </div>
                                <div class="body-1">
                                    {{ trans('form.label.unloadingTimeInMin') }}
                                </div>
                                <div class="body-1">
                                    {{ trans('form.label.created') }}
                                </div>
                                <div class="body-1">
                                    {{ trans('form.label.updated') }}
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs3>
                            <div>
                                <div class="body-1">
                                    : {{ getPreFlex(booking) }} mins
                                </div>
                                <div class="body-1">
                                    : {{ booking.UnloadingTimeInMins }} mins
                                </div>
                                <div class="body-1">
                                    : {{ booking.Created | formatDateTime }}
                                </div>
                                <div class="body-1">
                                    : {{ booking.Updated | formatDateTime }}
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card-title>
            </v-card>
        </div>

        <div
            v-if="this.booking.ActorType === 'PROPOSED SLOT'"
            class="tippy-popper"
            ref="proposedSlotTooltip"
        >
            <v-card
                class="white--text v-card-round"
                width="230"
                style="background: #2db4ff; padding: 10px"
            >
                <el-row>
                    <v-icon
                        style="
                            cursor: pointer;
                            float: right;
                            font-size: 20px;
                            margin-bottom: 5px;
                        "
                        @click.stop="tippy.hide()"
                        >close</v-icon
                    >
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <v-icon style="color: #ffffff">schedule</v-icon>
                        {{ trans('form.label.from') }}
                    </el-col>
                    <el-col :span="16">
                        <el-time-select
                            style="width: 130px"
                            placeholder="Start time"
                            v-model="fromTime"
                            :clearable="false"
                            size="mini"
                            :picker-options="{
                                format: 'HH:mm:ss',
                                start: '00:00',
                                step: timeStepper,
                                end: '23:30',
                            }"
                        >
                        </el-time-select>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 5px">
                    <el-col :span="8">
                        <v-icon style="color: #ffffff">schedule</v-icon>
                        {{ trans('form.label.to') }}
                    </el-col>
                    <el-col :span="16">
                        <el-time-select
                            style="width: 130px"
                            placeholder="End time"
                            v-model="toTime"
                            size="mini"
                            :clearable="false"
                            :picker-options="{
                                start: '00:00',
                                step: timeStepper,
                                end: '23:30',
                            }"
                        >
                        </el-time-select>
                    </el-col>
                </el-row>
                <el-row>
                    <v-btn
                        style="
                            position: relative;
                            margin-top: 10px;
                            margin-left: 27px;
                            background: #34c8b4 !important;
                            color: #ffffff !important;
                        "
                        flat
                        small
                        dark
                        align-center
                        color="primary"
                        @click="updateTime()"
                    >
                        {{ trans('button.text.update') }}
                    </v-btn>
                </el-row>
            </v-card>
        </div>
    </div>
</template>

<script>
import tippy from 'tippy.js'

export default {
    name: 'booking-event',

    props: {
        filters: {},

        booking: {
            type: Object,
            default: () => null,
        },

        trans: {
            default: () => null,
        },

        unloadingArea: {
            type: Object,
            default: () => null,
        },

        element: {
            type: Object,
            default: () => {},
        },

        readonly: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isClicked: false,
            isOverlapperd: false,
            fromTime: '',
            toTime: '',
            timeStepper: '00:15',
        }
    },
    computed: {
        color() {
            return this.unloadingArea ? this.unloadingArea.Color : '#FEA47F'
        },
        packageGroups() {
            return this.booking.PackageGroups
                ? this.booking.PackageGroups.slice().reverse()
                : []
        },
    },

    mounted() {
        this.addStyles()

        if (this.booking.ActorType === 'PROPOSED SLOT') {
            this.tippy = tippy.one(this.element.get(), {
                arrow: true,
                arrowTransform: 'scale(1.2)',
                html: this.$refs.proposedSlotTooltip.firstChild,
                interactive: true,
                placement: 'bottom',
                livePlacement: false,
                duration: 100,
                trigger: 'click',
                zIndex: 2000,
            })
            this.fromTime = this.booking.start.format('HH:mm')
            this.toTime = this.booking.end
                ? this.booking.end.format('HH:mm')
                : this.booking.start.format('HH:mm')
        } else {
            this.tippy = tippy.one(this.element.get(), {
                arrow: true,
                arrowTransform: 'scale(1.2)',
                html: this.$refs.tooltip.firstChild,
                interactive: true,
                livePlacement: false,
                duration: 100,
                trigger: 'click',
            })
        }

        this.$once('hook:beforeDestroy', () => {
            this.tippy.destroy()
        })

        Events.$on('highlight', (actorId) => {
            if (actorId === this.booking.ActorID) {
                this.isClicked = !this.isClicked
                if (this.isClicked) {
                    this.element.css('border-width', '3px')
                    this.element.css('border-color', '#000000')
                } else {
                    this.unhighlight(actorId)
                }
            }
        })

        Events.$on('unhighlight', (actorId) => {
            if (actorId !== this.booking.ActorID) {
                this.isClicked = false
                this.unhighlight()
            }
        })

        Events.$on('update-overlapping-status', (value) => {
            this.isOverlapperd = value
        })

        Events.$on('close-tippy', (value) => {
            this.tippy.destroy()
        })
    },

    beforeDestroy() {
        Events.$off('highlight')
        Events.$off('unhighlight')
    },

    methods: {
        unhighlight() {
            this.element.css('border-width', '2px')
            this.element.css('border-color', '#ffffff')
        },

        actorType(type = '') {
            if ('milkrun' === type.toLowerCase()) {
                return this.trans('text.milkrun').toUpperCase()
            }

            if ('SLOT' === type.toUpperCase()) {
                return this.trans('text.direct').toUpperCase()
            }

            if (
                'TENTATIVE' === type.toUpperCase() &&
                this.booking.Status === 1
            ) {
                return this.trans('text.waConfirmed')
            }

            if ('TENTATIVE' === type.toUpperCase()) {
                return this.trans('form.label.tentative')
            }

            return type
        },

        addStyles() {
            this.element.css('border-width', '2px')

            if (this.booking.ActorType === 'MILKRUN') {
                this.element.addClass('fc-event__milk-run fe-event__whiteBg')
                this.element.css('border-color', this.color)
            } else if (this.booking.ActorID === 'tempTentativeActor') {
                this.element.addClass('tempTentativeActor')
                this.element.css('border-width', '3px')
                this.element.css('border-color', '#000000')
                this.element.css('border-style', 'dashed')
                this.element.css('background', 'yellow')
            } else {
                this.element.css('border-color', '#FFFFFF')
                this.element.css('background', this.color)
            }
        },

        fireEvent(event, ...data) {
            this.tippy.hide()
            this.$emit(event, ...data)
        },

        toArray(data, key) {
            let str = ''

            if (data && data.length) {
                data.map((p) => {
                    str += `${p[key]}, `
                })
            }

            return str.trim().replace(/.$/, '')
        },

        getPreFlex(b) {
            let preFlex =
                b.AccessSets &&
                b.AccessSets[0] &&
                b.AccessSets[0].Schedules &&
                b.AccessSets[0].Schedules[0] &&
                b.AccessSets[0].Schedules[0].ScheduleParts &&
                b.AccessSets[0].Schedules[0].ScheduleParts[0] &&
                b.AccessSets[0].Schedules[0].ScheduleParts[0].PreFlex

            return preFlex || 0
        },

        checkImages(item) {
            if (item && item.PackageGroups && item.PackageGroups.length > 0) {
                for (const group of item.PackageGroups) {
                    if (group && group.Images && group.Images.length > 0) {
                        return true
                    }
                }
            }
        },

        openTimeline(actor) {
            Events.$emit(
                'show-timeline',
                actor.ActorID,
                'ACTOR',
                actor.BookingReference
            )
            this.tippy.hide()
        },

        subscribeNotifications(isSubscribed) {
            isSubscribed = !isSubscribed
            if (isSubscribed) {
                this.$http.post(`/NotificationSubscription/Subscribe`, {
                    LogLevel: 'INFO',
                    ReferenceCode: this.booking.BookingReference,
                    Data: this.booking.ActorID,
                })
            } else {
                this.$http.delete(
                    `/NotificationSubscription/ReferenceCode/${this.booking.BookingReference}/Data/${this.booking.ActorID}/UnSubscribe/LogLevel/Info`
                )
            }
            this.booking.IsSubscribed = isSubscribed
        },

        updateTime() {
            let timeArr1 = this.fromTime.split(':')
            let timeArr2 = this.toTime.split(':')

            let hour1 = timeArr1[0]
            let minutes1 = timeArr1[1]
            let hour2 = timeArr2[0]
            let minutes2 = timeArr2[1]

            let startTime = this.booking.start
            startTime.set({
                hour: hour1,
                minute: minutes1,
                second: 0,
                millisecond: 0,
            })

            let endTime = this.booking.end
                ? this.booking.end
                : this.booking.start
            endTime.set({
                hour: hour2,
                minute: minutes2,
                second: 0,
                millisecond: 0,
            })

            if (this.fromTime === this.toTime || startTime.isAfter(endTime)) {
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: this.trans('form.label.dateRangeValidationError'),
                })
                return false
            }

            this.booking.start = startTime
            this.booking.end = endTime

            this.fireEvent('update-tentative-booking', this.booking)
            this.tippy.hide()
        },
    },
}
</script>
<style>
.v-card-round {
    border-radius: 10px;
}
.tippy-tooltip {
    color: inherit !important;
    font-size: inherit !important;
    padding: 0 !important;
    max-width: inherit !important;
    text-align: inherit !important;
    background-color: transparent !important;
    z-index: 2000 !important;
}
.tippy-popper[x-placement^='top'] .tippy-arrow {
    border-top-color: #a5a5a5 !important;
}
.tippy-popper[x-placement^='bottom'] .tippy-arrow {
    border-bottom-color: #a5a5a5 !important;
}
.tippy-popper[x-placement^='left'] .tippy-arrow {
    border-left-color: #a5a5a5 !important;
}
.tippy-popper[x-placement^='right'] .tippy-arrow {
    border-right-color: #a5a5a5 !important;
}
.text_bold {
    font-weight: bold !important;
    text-shadow: 0.5px 0.5px #323b49;
}
.text_not_bold {
    font-weight: normal !important;
    text-shadow: none;
}
.tentative-confirmed-tag {
    background: #fffe40;
    padding: 0px 5px;
    color: #000000;
    border-style: dashed;
    border-width: 1px;
    border-color: #000000;
    height: 15px;
}
.el-picker-panel time-select el-popper {
    z-index: 99999 !important;
}

.tempTentativeActor {
    z-index: 500 !important;
}

.el-tooltip__popper.is-light {
    color: #ffffff !important;
    background-color: rgb(249, 113, 0) !important;
    border: 2px solid #000;
}
</style>
